<template>
  <div class="two-columns-content">
  <pre-header />

    <slot name="header" />

    <div class="two-columns-content__columns">

      <ul
        v-fade-on-top="$_fadeOnTop"
        class="two-columns-content__anchors--mobile"
        :class="{ 'two-columns-content__anchors--open': mobileMenuOpen, 'faded-on-top': fadedOnTop }">
        <div
          v-if="anchors.length > 0"
          class="two-columns-content__anchors__trigger"
          @click="mobileMenuOpen = !mobileMenuOpen">{{ anchors[scroll.activeAnchor].text }}</div>

        <li
          v-for="(anchor, index) of anchors"
          :key="index"
          @click="$_scrollToAnchor(anchor.element)">
          <span
            class="two-columns-content__trigger"
            :class="{ 'two-columns-content__trigger--active': index === scroll.activeAnchor }"
            @mouseover="updateMouseCursor('button')"
            @mouseout="updateMouseCursor('default')">
            {{ anchor.text }}
          </span>
        </li>
      </ul>

      <div
        v-read-anchors="$_anchorMapping"
        class="two-columns-content__right">

        <div
          v-show="!footerState"
          class="two-columns-content__left two-columns-content__left-inRight">
          <ul
            class="two-columns-content__anchors"
            :class="{ 'two-columns-content__anchors--open': mobileMenuOpen }">
            <li
              v-for="(anchor, index) of anchors"
              :key="index"
              @click="$_scrollToAnchor(anchor.element)">
              <span
                class="two-columns-content__trigger"
                :class="{ 'two-columns-content__trigger--active': index === scroll.activeAnchor }"
                @mouseover="updateMouseCursor('button')"
                @mouseout="updateMouseCursor('default')">
                {{ anchor.text }}
              </span>
            </li>
          </ul>
        </div>

        <div
          v-more-less
          class="block--content">
          <slot name="right-column" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import PreHeader from './PreHeader'
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    PreHeader
  },
  data: () => ({
    fadedOnTop: false,
    anchors: [],
    scroll: {
      lastPosition: 0,
      direction: undefined,
      activeAnchor: 0
    },
    mobileMenuOpen: false
  }),
  computed: {
    ...mapGetters([
      'footerState'
    ])
  },
  mounted () {
    window.addEventListener('scroll', this.$_scrollListener)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.$_scrollListener)
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_scrollListener () {
      this.scroll.direction = window.pageYOffset > this.scroll.lastPosition ? 'down' : 'up'
      this.scroll.lastPosition = window.pageYOffset
    },
    $_scrollToAnchor (el) {
      window.scrollTo({
        top: el.getBoundingClientRect().top + window.pageYOffset + 1,
        behavior: 'smooth'
      })

      this.mobileMenuOpen = false
    },
    $_anchorMapping (anchor) {
      return {
        element: anchor,
        text: anchor.dataset.anchor
      }
    },
    $_fadeOnTop (value) {
      this.fadedOnTop = value
    }
  },
  directives: {
    'more-less': {
      bind (el) {
        // TODO:
      }
    },
    'read-anchors': {
      bind (el, binding, vnode) {
        const anchors = Array.prototype.slice.call(el.querySelectorAll('.anchor'))
        const bottomAnchors = Array.prototype.slice.call(el.querySelectorAll('.bottom-anchor'))

        // you must define pairs
        if (anchors.length !== bottomAnchors.length) return console.warn('anchors and bottom-anchors are not even')

        const anchorsObserver = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            if (entry.target.classList.contains('anchor') &&
            !entry.isIntersecting &&
            vnode.context.$data.scroll.direction === 'down') {
              vnode.context.$data.scroll.activeAnchor = anchors.indexOf(entry.target)
            }
          })
        })

        const bottomAnchorsObserver = new window.IntersectionObserver(entries => {
          _.forEach(entries, entry => {
            if (entry.target.classList.contains('bottom-anchor') &&
            !entry.isIntersecting &&
            vnode.context.$data.scroll.direction === 'up') {
              vnode.context.$data.scroll.activeAnchor = bottomAnchors.indexOf(entry.target)
            }
          })
        })

        _.forEach(anchors, anchor => { anchorsObserver.observe(anchor) })
        _.forEach(bottomAnchors, anchor => { bottomAnchorsObserver.observe(anchor) })

        vnode.context.$data.anchors = _.map(anchors, binding.value)
      }
    },
    'fade-on-top': {
      bind (el, binding) {
        window.addEventListener('scroll', () => {
          binding.value(el.getBoundingClientRect().top <= 0)
        })
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint.scss';

.two-columns-content{

  $marginLeftRight: 7.5%;
  $marginLeftRightDesktop: 15%;
  $marginBottom: 15%;
  $padding: 7.5rem;
  $paddingDesktop: 17.5rem;
  $paddingDesktopTop: 30rem;

  .anchor {
    transform: translateY(-75px);
    display: block;
  }

  .block--header{
    padding: $paddingDesktop $marginLeftRight $padding;
    @include media(">=large"){
      padding: 17.5rem $marginLeftRightDesktop 12.5rem;
    }
    @include media(">=xlarge"){
      padding: 30rem $marginLeftRightDesktop 17.5rem;
    }
  }

}

.two-columns-content__columns {
  position: relative;
}

.two-columns-content__anchors {
  list-style: none;
  position: relative;
  padding-left: 7.5%;
  margin-top: 0;

}
.two-columns-content__left-inRight{
  padding-left: 7.5%;
  display: flex;
  ul{
    padding: 0;
  }
  @include media(">=large"){
    padding-left: 4%;
  }
}

.two-columns-content__anchors li {
  cursor: pointer;

  &:not(:last-child){
    margin-bottom: 1.75rem;
  }

}

.two-columns-content__anchors--mobile {
  margin: 0;
  padding: 0;
  color: #e30045;
  background-color: #f2f2f2;
  position: sticky;
  top: -1px;
  z-index: 200;
  margin-bottom: 3rem;
  opacity: 0;
  transition: opacity .3s;

  @include media(">=large"){
    display: none;
  }

  &.faded-on-top {
    opacity: 1;
  }

  .two-columns-content__anchors__trigger {
    background-color: #0b3277;
    background-image: url('../../assets/img/down-nav-ico.svg');
    background-repeat: no-repeat;
    background-position: 92.5% center;
    color: white;
    padding: 2rem 7.5%;
    cursor: pointer;
    font-size: 1.8rem;
  }

  li {
    transition: all .5s;
    opacity: 0;
    padding: 0;
    max-height: 0;
    padding: 0 7.5%;
  }
}

.two-columns-content__anchors--open {
  li {
    opacity: 1;
    max-height: 300px;
    padding: 1rem 7.5%;

    &:nth-child(2){
      padding-top: 3.5rem;
    }
    &:last-child{
      padding-bottom: 3.5rem;
    }
  }
}

.two-columns-content__anchors--mobile{
  .two-columns-content__trigger{
    display: inline-block;
    position: relative;
    font-size: 1.8rem;
    color: #0b3277;
    line-height: 1.7;
    padding-bottom: .25rem;
    white-space: nowrap;
    &:after{
      display: none;
    }
  }
}

.two-columns-content__left {
  position: relative;
  margin-bottom: 7.5rem;
  @include media(">=medium"){
    margin-bottom: 12.5rem;
  }
  @include media(">=large"){
    margin-bottom: 0;
    position: sticky;
    height: 0;
    z-index: 10;
    top: 25%;
  }
}

.two-columns-content__right {
  width: 100%;
  position: relative;
}

.two-columns-content__right p {
  margin-left: 25%;
}

.two-columns-content__right .full-width-video {
  width: 100%;
  position: relative;
  height: 0;
  padding-bottom: 66.67%;
}

.two-columns-content__right .full-width-video iframe {
  width: 100%;
  height: 100%;
  position: absolute;
}

/* @group Layout */

.two-columns-content{

  $marginLeft: 7.5%;
  $marginRight: 7.5%;
  $marginLeftDesktop: 40%;
  $marginRightDesktop: 15%;
  $marginBottom: 10rem;
  $marginBottomDesktop: 15rem;
  $marginLeftRight: 7.5%;
  $marginLeftRightDesktop: 31%;

  .block--content{
    & > h3, & > h4, & >  p{
      margin-left: $marginLeft;
      margin-right: $marginRight;
      &:first-of-type{
        margin-top: 0;
      }
      @include media(">=large"){
        margin-left: $marginLeftDesktop;
        margin-right: $marginRightDesktop;
      }
    }

    .rossetto-video {
      margin-left: 15%;
      width: 100%;
      position: relative;
      margin: 0 0 100px 0;

      @include media(">=large"){
        margin: 140px 0 170px 0;
        margin-left: 31%;
        width: 69%;  // xdlol
      }

      iframe {
        width: 100%;
      }
    }

    & > .accordion {
      margin-left: 0;
      margin-right: 0;

      p {
        margin-left: 0;
      }

      @include media(">=large"){
        margin-left: 30%;
        margin-right: 5%;

        .accordion-element__trigger {
          padding-right: 0;
        }
      }
    }

    & > figure.figure-padded {
      margin-left: $marginLeftRight;
      margin-right: $marginLeftRight;
      @include media(">=large"){
        margin-left: $marginLeftRightDesktop;
        margin-right: 0;
      }
    }

    & > p, & > figure, & > .full-width-video, & > .slider{
      margin-bottom: $marginBottom;
      @include media(">=large"){
        margin-bottom: $marginBottomDesktop;
      }
    }
    h4 + figure, h4 + .full-width-video{
      margin-top: $marginBottom;
      @include media(">=large"){
        margin-top: $marginBottomDesktop;
      }
    }

    & > figure:last-of-type{
      margin-bottom: 0
    }
  }

}

/* @end */

/* @group Anchor Navigation */

.two-columns-content__trigger {
  display: inline-block;
  position: relative;
  font-size: 1.8rem;
  color: #0b3277;
  line-height: 1.7;
  padding-bottom: .25rem;
  transform: translate3d(0,0,0);
  white-space: nowrap;
}

.two-columns-content__trigger:after {
  display: block;
  content: "";
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: #0b3277;
  transform: scaleX(0);
  transition: transform .3s ease-out;
}

.two-columns-content__trigger:hover:after, .two-columns-content__trigger--active:after {
  transform: scaleX(1);
}

/* @end */

</style>
